import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import AddIcon from '@material-ui/icons/Add';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { MODALS } from 'src/models/ModalModel';
import { openModal } from 'src/redux/actions/modalActions';
import { useAppDispatch, Store } from 'src/redux/Store';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';

const AddSubscriptionButton = (props: ButtonProps) => {
  const { disabled } = props;

  const dispatch = useAppDispatch();

  const handleOpen = () => {
    dispatch(openModal({ modal: MODALS.addSubscription }));
  };

  const lang = useSelector((state: Store) => state.language.language);

  return (
    <Tooltip
      title={t(lang, 'menus.add_subscription')}
      placement="top-start">
      <span>
        <ActionButton
          id="add-subscription-button"
          variant="outlined"
          category={MENU_BUTTON_CATEGORY.action}
          onClick={handleOpen}
          disabled={disabled}>
          <AddIcon />
        </ActionButton>
      </span>
    </Tooltip>
  );
};

export default AddSubscriptionButton;
